<template>
    <body>
        <main app="">
            <span
                ><div class="flex xs12">
                    <div class="card" style="height: auto">
                        <div class="container fluid">
                            <div class="layout">
                                <div class="flex pa-3">
                                    <h1>Gallery</h1>
                                    <p class="py-1">
                                        Click on the arrows to browse through
                                        the Seikatsu collection. Click on a
                                        painting to learn more about it.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout row mb-3">
                    <div class="flex text-xs-center xs12">
                        <div class="card" style="height: auto">
                            <div class="layout">
                                <div class="flex">
                                    <div
                                        class="card card--flat"
                                        style="height: auto"
                                    >
                                        <div
                                            class="container fluid grid-list-md"
                                        >
                                            <div
                                                class="layout row justify-center align-center mt-2 mb-2"
                                            >
                                                <button
                                                    disabled="disabled"
                                                    type="button"
                                                    class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-double-left"
                                                        ></i>
                                                    </div>
                                                </button>
                                                <button
                                                    disabled="disabled"
                                                    type="button"
                                                    class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-left"
                                                        ></i>
                                                    </div>
                                                </button>
                                                <div
                                                    align-center=""
                                                    class="card__title"
                                                >
                                                    <h1>In the beginning</h1>
                                                    <!---->
                                                    <!---->
                                                </div>
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-double-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_double_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                            </div>
                                            <div
                                                class="layout row justify-center align-center mt-0 mb-0"
                                            >
                                                <div
                                                    class="menu"
                                                    style="display: block"
                                                >
                                                    <div
                                                        class="menu__activator"
                                                    >
                                                        <div
                                                            class="input-group input-group--dirty input-group--prepend-icon input-group--text-field primary--text"
                                                        >
                                                            <label
                                                                >Go to
                                                                date...</label
                                                            >
                                                            <div
                                                                class="input-group__input"
                                                            >
                                                                <i
                                                                    aria-hidden="true"
                                                                    class="icon material-icons input-group__prepend-icon"
                                                                    >event</i
                                                                ><input
                                                                    tabindex="0"
                                                                    aria-label="Go to date..."
                                                                    type="text"
                                                                />
                                                            </div>
                                                            <div
                                                                class="input-group__details"
                                                            >
                                                                <!---->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="layout row wrap">
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/0"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #0
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 0 -
                                                                575</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/00000000-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/1"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #1
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 576 -
                                                                1,151</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/00000576-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/2"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #2
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 1,152 -
                                                                1,727</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/00001152-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/3"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #3
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 1,728 -
                                                                2,303</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/00001728-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/4"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #4
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 2,304 -
                                                                2,879</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/00002304-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/5"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #5
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks 2,880 -
                                                                3,455</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/00002880-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout row">
                    <div class="flex text-xs-center xs12">
                        <div class="card" style="height: auto">
                            <div class="layout">
                                <div class="flex">
                                    <div
                                        class="card card--flat"
                                        style="height: auto"
                                    >
                                        <div
                                            class="container fluid grid-list-md"
                                        >
                                            <div
                                                class="layout row justify-center align-center mt-2 mb-2"
                                            >
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_double_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                                <div
                                                    align-center=""
                                                    class="card__title"
                                                >
                                                    <!---->
                                                    <h1>Latest</h1>
                                                    <!---->
                                                </div>
                                                <button
                                                    disabled="disabled"
                                                    type="button"
                                                    class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                                <button
                                                    disabled="disabled"
                                                    type="button"
                                                    class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                    mt-4=""
                                                >
                                                    <div class="btn__content">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon theme--dark fas fa-angle-right material-icons"
                                                            style="
                                                                display: flex;
                                                            "
                                                            >keyboard_double_arrow_right</i
                                                        >
                                                    </div>
                                                </button>
                                            </div>
                                            <div
                                                class="layout row justify-center align-center mt-0 mb-0"
                                            >
                                                <div
                                                    class="menu"
                                                    style="display: block"
                                                >
                                                    <div
                                                        class="menu__activator"
                                                    >
                                                        <div
                                                            class="input-group input-group--dirty input-group--prepend-icon input-group--text-field primary--text"
                                                        >
                                                            <label
                                                                >Go to
                                                                date...</label
                                                            >
                                                            <div
                                                                class="input-group__input"
                                                            >
                                                                <i
                                                                    aria-hidden="true"
                                                                    class="icon material-icons input-group__prepend-icon"
                                                                    >event</i
                                                                ><input
                                                                    tabindex="0"
                                                                    aria-label="Go to date..."
                                                                    type="text"
                                                                />
                                                            </div>
                                                            <div
                                                                class="input-group__details"
                                                            >
                                                                <!---->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="layout row wrap">
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9889"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #9889
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,696,064 -
                                                                5,696,639</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/05696064-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9890"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #9890
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,696,640 -
                                                                5,697,215</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/05696640-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9891"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #9891
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,697,216 -
                                                                5,697,791</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/05697216-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9892"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #9892
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,697,792 -
                                                                5,698,367</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/05697792-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9893"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #9893
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,698,368 -
                                                                5,698,943</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/05698368-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                                <div
                                                    class="flex xs12 sm6 md4 lg4 xl4"
                                                >
                                                    <a
                                                        href="https://www.CryptoArte.io/paintings/9894"
                                                        class="ma-2 pa-3 pt-0 card card--hover"
                                                        style="height: auto"
                                                        ><div
                                                            class="card__text"
                                                        >
                                                            <h5
                                                                class="headline ma-0"
                                                            >
                                                                Painting #9894
                                                            </h5>
                                                            <span
                                                                class="grey--text ma-0"
                                                                >Blocks
                                                                5,698,944 -
                                                                5,699,519</span
                                                            >
                                                            <span
                                                                class="blue--text ma-0"
                                                                ><strong
                                                                    >SOLD</strong
                                                                ></span
                                                            >
                                                            <!---->
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div
                                                            class="card__media"
                                                            style="
                                                                height: 216px;
                                                            "
                                                        >
                                                            <div
                                                                class="card__media__background"
                                                                style="
                                                                    background: url('https://storage.googleapis.com/pcarte/images/mid/05698944-public-mid.png')
                                                                        center
                                                                        center /
                                                                        contain
                                                                        no-repeat;
                                                                "
                                                            ></div>
                                                            <div
                                                                class="card__media__content"
                                                            ></div></div
                                                    ></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div></div
            ></span>
        </main>
        <footer class="footer" style="height: auto">
            <div class="layout row wrap justify-center cyanBlue lighten-1">
                <div
                    class="cyanBlue lighten-1 text-xs-center card card--flat card--tile"
                    style="height: auto"
                >
                    <div class="card__text">
                        <a
                            href="https://twitter.com/CryptoArte"
                            target="_blank"
                            class="mx-3 white--text btn btn--icon"
                            ><div class="btn__content">
                                <i
                                    aria-hidden="true"
                                    class="icon theme--dark fab fa-twitter"
                                    style="font-size: 24px"
                                ></i></div
                        ></a>
                        <span
                            ><a
                                href="mailto:hello@CryptoArte.io"
                                target="_blank"
                                class="mx-3 white--text btn btn--icon"
                                ><div class="btn__content">
                                    <i
                                        aria-hidden="true"
                                        class="icon theme--dark fas fa-envelope"
                                        style="font-size: 24px"
                                    ></i></div></a
                        ></span>
                    </div>
                    <!---->
                    <div class="card__text white--text pt-0">
                        ©2021 — <strong>CryptoArte, LLC</strong> -
                        <a href="/terms" class="white--text pt-0"
                            >Terms &amp; Conditions</a
                        >
                    </div>
                </div>
            </div>
        </footer>
        <!-- <script
        type="text/javascript"
        src="/static/js/manifest.5f946d972125a67eabf1.js"
    ></script>
    <script
        type="text/javascript"
        src="/static/js/vendor.e47676f654e7bc42a06c.js"
    ></script>
    <script
        type="text/javascript"
        src="/static/js/app.020921c3752b3f33b6dd.js"
    ></script>-->
        <iframe
            frameborder="0"
            allowtransparency="true"
            src="https://checkout.stripe.com/v3/JdhudoUwvSFS85kPDZEQ.html?distinct_id=a7fb34eb-be29-492c-84d1-59aef3884e89"
            name="stripe_checkout_app"
            class="stripe_checkout_app"
            style="
                z-index: 2147483647;
                display: none;
                background: rgba(0, 0, 0, 0.004);
                border: 0px none transparent;
                overflow: hidden auto;
                visibility: visible;
                margin: 0px;
                padding: 0px;
                -webkit-tap-highlight-color: transparent;
                position: fixed;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
            "
        ></iframe>
    </body>
</template>

<script>
/* eslint-disable vue/no-unused-components */
export default {
    name: "Gallery",
    data() {
        return {
            info: [
                { id: "0", text: "John" },
                { id: "1", text: "Mary" },
            ],
        };
    },
    methods: {
        isMobile() {
            return true;
            /* return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent);
            */
        },
    },
    mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute(
            "src",
            "https://www.google.com/recaptcha/api.js"
        );
        document.head.appendChild(recaptchaScript);
    },
};
</script>

<style></style>
